import { MenuItem } from '@chakra-ui/react';
import { truncateName } from '../../../utils/truncate';
import { MaterialIcon } from '../../ui/MaterialIcon';

interface CreateHereMenuItemProps {
  readonly scopeName: string;
  readonly onClick: () => void;
}

/**
 * The one create entry in a right-click or kebab menu: opens the Create
 * modal aimed at this folder, so menus, the rail and the page all create the
 * same way.
 */
export function CreateHereMenuItem({ scopeName, onClick }: CreateHereMenuItemProps) {
  return (
    <MenuItem
      icon={<MaterialIcon name="add" boxSize={4} color="inherit" />}
      onClick={onClick}
      data-testid="create-here-menu-item"
      aria-label={`Create in ${scopeName}`}
    >
      {`Create in ${truncateName(scopeName)}…`}
    </MenuItem>
  );
}
